// The sub-tabs of a merchant portal panel as a dropdown on a phone or a small tablet (the tabs
// themselves from lg, or from `from`): the Company and Settings tabs, the store availability and the
// courier dialogs.
import React from "react"
import DropdownSelect from "aldoo-ra/DropdownSelect"

/**
 * A panel's sub-tabs on a phone or a small tablet (below lg, where the tabs hide): a dropdown (a row of
 * tabs scrolled sideways is easily missed), each still marked "!" while it lacks something. Its options
 * come up in a bottom sheet headed `title` on a phone; `sheet={false}`: the plain list under it (inside
 * a dialog, a sheet over the dialog would be one layer too many). `from`: the breakpoint the tabs take
 * over at (sm, md or lg) — the host shows its tabs from the same one.
 */
// whole class names, for Tailwind to find
const HIDDEN_FROM = { sm: "sm:hidden", md: "md:hidden", lg: "lg:hidden" }

export default function SectionPicker({ tabs, value, onChange, title, testId, sheet = true, from = "lg", className = "" }) {
  return (
    <div className={`${HIDDEN_FROM[from] || HIDDEN_FROM.lg} ${className}`} data-testid={testId}>
      <DropdownSelect
        variant="admin"
        options={tabs}
        value={tabs.filter((x) => x.value === value)}
        nameField="label"
        showCheckbox={false}
        showSelectionTick
        enableResetButton={false}
        allowEmptySelection={false}
        optionsAsBottomDrawer={sheet}
        dialogTitle={title}
        onChange={(sel) => {
          const picked = Array.isArray(sel) ? sel[0] : sel
          if (picked?.value) onChange(picked.value)
        }}
        onItemRender={(x) => {
          const item = Array.isArray(x) ? x[0] : x
          return (
            <span className="flex items-center gap-2 text-sm">
              {item?.label}
              {item?.badge && <span className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[11px] leading-none ${item.badgeClassName || ""}`}>{item.badge}</span>}
            </span>
          )
        }}
      />
    </div>
  )
}
